import RequireUserMiddleware from 'middlewares/RequireUserMiddleware'
import RequireSignupFinishedMiddleware from 'middlewares/RequireSignupFinishedMiddleware'

export default [
    ...[{ type: 'upload', tabType: 'patients' }].map(({ type, tabType }) => ({
        path: `/patients/${type}/${tabType}`,
        name: `patients.${type}.${tabType}`,
        view: 'patient/Upload',
        middlewares: [RequireSignupFinishedMiddleware, RequireUserMiddleware],
    })),
    ...[{ type: 'list', tabType: 'patients' }].map(({ type, tabType }) => ({
        path: `/patients/${type}/${tabType}`,
        name: `patients.${type}.${tabType}`,
        view: 'patient/PatientList',
        middlewares: [RequireSignupFinishedMiddleware, RequireUserMiddleware],
    })),
    ...[{ type: 'details', tabType: 'patients' }].map(({ type, tabType }) => ({
        path: `/patients/${type}/${tabType}/:id?`,
        name: `patients.${type}.${tabType}`,
        view: 'patient/PatientAllDetail',
        middlewares: [RequireSignupFinishedMiddleware, RequireUserMiddleware],
    })),
]
